import { render, staticRenderFns } from "./OffererForm.vue?vue&type=template&id=06d8aee6&"
import script from "./OffererForm.vue?vue&type=script&lang=js&"
export * from "./OffererForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports